<template>
	<a class="column-card" :data-channelid="channelid" @click="handleClick($event, channelid, uri, name, icon)">
		<div v-show="showtip" class="tip-alert">耐心等待</div>
		<div v-if="num > 0" class="column-card__msg">{{num}}</div>
		<div class="column-card__img">
			<img class="column-card__icon" :src="icon" alt="">
		</div>
		<div class="column-card__name" >{{name}}</div>
		<div v-if="tip" class="column-card__txt">{{tip}}</div>
	</a>
</template>

<script>
import { setTimeout } from 'timers';
export default {
	name: 'ColumnCard',
	data () {
		return {
			showtip: this.showAlert
		};
	},
	props: {
		showAlert: {
			type: Boolean,
			default () { return false; }
		},
		icon: {
			type: String,
			default () { return ''; }
		},
		num: {
			type: Number,
			default () { return 0; }
		},
		name: {
			type: String,
			default () { return ''; }
		},
		tip: {
			type: String,
			default () { return ''; }
		},
		channelid: {
			type: [String, Number],
			default () { return ''; }
		},
		uri: {
			type: String,
			default () { return ''; }
		}
	},
	methods: {
		handleClick (e, channelid, uri, name, icon) {
			let _self = this;
			if (!uri) {
				_self.showtip = true;
				setTimeout(function () {
					_self.showtip = false;
				}, 2000);
			} else {
				if (name === 'EE报销') {
					localStorage.setItem('logo-ee', icon);
				}
				_self.$emit('on-click', e, channelid, uri);
			}
		}
	}
};
</script>

<style lang="scss">
.column{
	&__top{
		display: flex;
        margin-bottom: 0.18rem;
		justify-content: space-between;
		align-items: center;
	}
	&__action{
		font-size: 0.14rem;
		color: #001E46;
		margin-right: 0.28rem;
		padding-right: 0.15rem;
		&.show{
			&::before{
				content: '展开';
				margin-right: 2px;
				display: inline-block;
				vertical-align: middle;
			}
			&::after{
				content: '';
				display: inline-block;
				vertical-align: middle;
				width: 0.15rem;
				height: 0.15rem;
				background: url(../assets/images/arrow.png) no-repeat center center;
				background-size: auto 0.14rem;
			}
		}
		&.hide{
			&::before{
				content: '收起';
				margin-right: 2px;
				display: inline-block;
				vertical-align: middle;
			}
			&::after{
				content: '';
				display: inline-block;
				vertical-align: middle;
				width: 0.15rem;
				height: 0.15rem;
				background: url(../assets/images/arrow.png) no-repeat center center;
				background-size: auto 0.14rem;
				transform: rotate(90deg);
			}
		}
	}
    &__name{
        position: relative;
        min-width: 1.06rem;
        box-sizing: border-box;
		padding-left: 0.26rem;
		padding-right: 0.2rem;
        font-size: 0.16rem;
        color: #004C87;
        height: 0.3rem;
        line-height: 0.3rem;
        background: #E6F0F6;
        border-top-right-radius: 0.15rem;
        border-bottom-right-radius: 0.15rem;
        &::before{
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 0.3rem;
            width: 0.05rem;
            background: #1D4B83;
            border-top-right-radius: 0.05rem;
            border-bottom-right-radius: 0.05rem;
        }
    }
    &__list{
        display: flex;
		padding: 0 0.23rem;
		flex-wrap: wrap;
    }
    &-card{
        position: relative;
        text-decoration: none;
        display: block;
        width: 0.8rem;
        margin-bottom: 0.16rem;
        text-align: center;
        margin-right: 0.44rem;
        &:nth-of-type(3n) {
            margin-right: 0;
		}
		&__msg{
			border-radius: 0.1rem;
			display: inline-block;
			padding: 0 0.05rem;
			color: #ffffff;
			background: #E35240;
			position: absolute;
			right: 0;
		}
        &__name{
            font-size: 0.14rem;
            color: #52565A;
        }
        &__img{
            width: 0.8rem;
            height: 0.8rem;
			margin-bottom: 0.05rem;
			background: url(../assets/images/img-loading.png) no-repeat center center;
			background-size: 0.5rem auto;
            img{
                width: 100%;
                height: auto;
            }
        }
        &__txt{
            font-size: 0.1rem;
            color: #90979D;
        }
		.tip-alert{
			position: absolute;
			top: -0.25rem;
			left: -0.02rem;
			background: url(../assets/images/bg-tip.png) no-repeat center center;
			background-size: 100% 100%;
			font-size: 0.14rem;
			color: #004C87;
			text-align: center;
			width: 0.88rem;
			height: 0.34rem;
			line-height: 0.3rem;
		}
    }
}
</style>
